module.exports = __webpack_public_path__ + "static/media/4.e47a6d4a.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/pioricost-fruit/certificaciones/4.png
// module id = 53
// module chunks = 0